import { useMemo } from 'react';
import { useShowHide, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { getSessionStorage } from '@helpers';
import { modals } from '@modals';
import { useNavigation } from '@navigation';
import { exit } from 'process';

interface ExitModalOutput {
	resources: ExitModalResources;
	onHandleRequestContact: () => void;
	onHandleContinue: () => void;
	onHandleLeave: () => void;
}

interface ExitModalResources {
	title: string;
	subtitle: string;
	requestContact: string;
	continue: string;
	leave: string;
}

export const useExitModule = (): ExitModalOutput => {
	const t = useTranslation();
	const { navigate, exit } = useNavigation();
	const { hide } = useShowHide(modals.exitModule);

	const resources = useMemo((): ExitModalResources => {
		return {
			title: t('modals.exitModule.title'),
			subtitle: t('modals.exitModule.subtitle'),
			requestContact: t('modals.exitModule.requestContact'),
			continue: t('modals.exitModule.continue'),
			leave: t('modals.exitModule.exit'),
		};
	}, [t]);

	const onHandleRequestContact = () => {
		navigate('requestContact');
	};

	const onHandleContinue = () => {
		hide();
	};

	const onHandleLeave = () => {
		exit();
	};

	return { resources, onHandleRequestContact, onHandleContinue, onHandleLeave };
};
